import {Typography} from "../..";
import {useTheme} from "styled-components";
import {Eye, EyeOff, Icon} from "react-feather";
import {CSSProperties, InputHTMLAttributes, useState} from "react";
import {
  Container,
  IconLabel,
  IconPassword,
  InputStyled,
  typographyErrorProps,
} from "./styled";

export interface InputPasswordProps
  extends InputHTMLAttributes<HTMLInputElement> {
  icon?: Icon;
  label?: string;
  touched?: boolean;
  helperErrorText?: string;
  containerStyle?: CSSProperties;
}

export const InputPassword: React.FC<InputPasswordProps> = (props) => {
  const [show, setShow] = useState<boolean>(false);
  const {placeholderTextColor, blackWhite} = useTheme();
  const [tempValue, setTempValue] = useState<string>("");
  const {
    label,
    style,
    icon: Icon,
    containerStyle,
    touched = false,
    helperErrorText,
    ...inputProps
  } = props;
  const {placeholder = "", name, onChange} = inputProps;
  const EyeIcon = show ? Eye : EyeOff;

  return (
    <Container style={containerStyle}>
      {label && <Typography fontWeight="500">{label}</Typography>}
      <div style={{position: "relative"}}>
        <InputStyled
          id={name}
          placeholder={placeholder}
          type={show ? "text" : "password"}
          style={{
            ...style,
            padding: Icon ? "0.8rem 0.8rem 0.8rem 45px" : "0.8rem",
          }}
          {...inputProps}
          onChange={(event) => {
            setTempValue(event["target"]["value"]);
            if (onChange) onChange(event);
          }}
        />
        {Icon && (
          <IconLabel htmlFor={name}>
            <Icon
              size={20}
              color={tempValue ? blackWhite : placeholderTextColor}
            />
          </IconLabel>
        )}
        <IconPassword onClick={() => setShow((prev) => !prev)}>
          <EyeIcon
            size={20}
            color={tempValue ? blackWhite : placeholderTextColor}
          />
        </IconPassword>
      </div>
      {helperErrorText && touched && (
        <Typography {...typographyErrorProps}>{helperErrorText}</Typography>
      )}
    </Container>
  );
};
